import { useState } from 'react';
import { Button, Checkbox, FormControlLabel, Stack, TextField } from '@mui/material';
import { formatJordan } from '@serb/shared';
import { useAction } from '../../lib/useAction';
import { clockApi, isHeld } from './useClock';

const EMPTY = { title: '', code: '', at: '', urgent: false };

/** The form for a new reminder. It is saved on the server; `onAdded` runs once it is. */
export function AddReminderForm({ onAdded }: { onAdded?: () => void }) {
  const [form, setForm] = useState(EMPTY);
  const set = (patch: Partial<typeof EMPTY>) => setForm((f) => ({ ...f, ...patch }));
  const add = useAction(clockApi.add, {
    success: (a) =>
      `Added. It will arrive ${formatJordan(a.deliverAt)}${isHeld(a) ? ' (held to working hours).' : '.'}`,
    onDone: () => {
      setForm(EMPTY);
      onAdded?.();
    },
  });

  return (
    <Stack spacing={1.5}>
      <TextField
        label="What"
        placeholder="e.g. Chase agent for rates"
        value={form.title}
        onChange={(e) => set({ title: e.target.value })}
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <TextField
          label="SRB code (optional)"
          placeholder="SRB-123"
          value={form.code}
          onChange={(e) => set({ code: e.target.value })}
        />
        <TextField
          label="When (Jordan time)"
          type="datetime-local"
          value={form.at}
          onChange={(e) => set({ at: e.target.value })}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </Stack>
      <FormControlLabel
        control={<Checkbox checked={form.urgent} onChange={(e) => set({ urgent: e.target.checked })} />}
        label="Urgent (may arrive any time)"
      />
      <Button variant="contained" disabled={add.busy} onClick={() => add.run(form)}>
        Add reminder
      </Button>
    </Stack>
  );
}
